import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NewsItem } from '../interfaces/newsitem';
import { catchError, defer, Observable, throwError } from 'rxjs';
import { Donor } from '../interfaces/donor';

@Injectable({
  providedIn: 'root'
})
export class NewsitemService {
  private apiUrl = environment.apiUrl + 'newsitems';

  constructor(private http: HttpClient) {}

  createNewsItem(newsItemData: NewsItem): Observable<NewsItem> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<NewsItem>(this.apiUrl, newsItemData, { headers }).pipe(
      catchError((error) => {
        console.error('Error creating newsitem:', error);
        return throwError(() => new Error('Failed to create newsitem'));
      })
    );
  }

  //TODO: Should filter based on user role and what is visible, atleast for dashboard
  getAllNewsItems$(): Observable<NewsItem[]> {
    return this.http.get<NewsItem[]>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching news items:', error);
        return throwError(() => new Error('Failed to fetch news items'));
      })
    );
  }

  updateNewsItem(newsItemData: NewsItem): Observable<NewsItem> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .patch<NewsItem>(`${this.apiUrl}/${newsItemData.id}`, newsItemData, {
        headers
      })
      .pipe(
        catchError((error) => {
          console.error('Error updating news item:', error);
          return throwError(() => new Error('Failed to update news item'));
        })
      );
  }

  deleteNewsItem(newsItemId: string): Observable<NewsItem> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.delete<NewsItem>(`${this.apiUrl}/${newsItemId}`, { headers }).pipe(
      catchError((error) => {
        console.error('Error deleting news item:', error);
        return throwError(() => new Error('Failed to delete news item'));
      })
    );
  }
}
